import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import EngineeringCoursesDetails from './section-components/engineering-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const Engineering = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>#1 Guidance Program for Engineering and Architecture Chennai</title>
            <meta name="description" content="MIET provides guidance programs for engineering and architecture aspirants. Our aim is to equip the students with the necessary knowledge and skill-sets." />
        </Helmet>
        <PageHeader headertitle="Engineering and Architecture Guidance Program"  />
        <EngineeringCoursesDetails />
        <Footer />
    </div>
}

export default Engineering